// @spec DHB-STR-009
// Redirect legacy /datahub/entry to combined /datahub/upload?tab=manual

import { createFileRoute, redirect, Outlet, useRouterState } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/datahub/entry')({
  component: EntryLayout,
  beforeLoad: ({ location }) => {
    // Only redirect the exact /datahub/entry path, not child routes like /datahub/entry/wizard
    if (location.pathname === '/datahub/entry' || location.pathname === '/datahub/entry/') {
      throw redirect({ to: '/datahub/upload', search: { tab: 'manual' } });
    }
  },
});

/**
 * Layout for child routes (wizard) — these still need their own routes.
 */
function EntryLayout() {
  const routerState = useRouterState();
  const currentPath = routerState.location.pathname;
  const isChildRouteActive = currentPath.includes('/datahub/entry/');

  if (isChildRouteActive) {
    return <Outlet />;
  }

  // Fallback — should not reach here due to redirect
  return null;
}
